import React, { useState, useEffect } from "react";
import DataTable from "../../Common/DataTable/DataTable";
import styles from "./mcb.module.css";
import { mcbDocumentList, mcbDocumentView } from "../../api";
import CustomSpinner from "../../Common/Spinner";
import { IoDocumentsOutline } from "react-icons/io5";
import { FaRegFileVideo } from "react-icons/fa6";
import { FaRegFileImage } from "react-icons/fa";
import { DocumentView } from "./DocumentView";

const Document = ({ userId }) => {
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const renderDocButton = (docLink, userDocId, docType, docIndex, title) => {
    if (!docLink) return <span>--</span>;

    return (
      <button
        onClick={() =>
          handleViewDocuments({
            userDocId,
            docType,
            docIndex,
          })
        }
        className={styles.viewButton}
        title={title}
      >
        {docIndex === 2 && docType === "SELFIEE" ? (
          <FaRegFileVideo size={20} />
        ) : (
          <FaRegFileImage size={20} />
        )}
      </button>
    );
  };

  const documentColumns = [
    {
      Header: "Document Type",
      accessor: "docType",
      formatText: true,
      Cell: ({ row }) => {
      const value = row.original.docType;
      if (value === "SELFIEE") {
        return "Selfie & Liveness Video";
      }
      return value
        ?.toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },

    {
      Header: "Reason",
      accessor: "comment",
    },

    {
      Header: "Created At",
      accessor: "createdAt",
    },
    {
      Header: "Doc 1",
      accessor: "docLink_1",
      Cell: ({ row }) =>
        renderDocButton(
          row.original.docLink_1,
          row.original.userDocId,
          row.original.docType,
          1,
          "View Document 1"
        ),
    },
    {
      Header: "Doc 2",
      accessor: "docLink_2",
      Cell: ({ row }) =>
        renderDocButton(
          row.original.docLink_2,
          row.original.userDocId,
          row.original.docType,
          2,
          "View Document 2"
        ),
    },
  ];

  const fetchDocuments = async () => {
    try {
      setDataLoading(true);
      const response = await mcbDocumentList(userId);

      if (response?.status === 200) {
        setDocuments(response.data);
      } else {
        setError("Documents not found");
      }
    } catch (error) {
      setError("Error fetching documents");
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [userId]);

  const handleViewDocuments = async (doc) => {
    try {
      const response = await mcbDocumentView(userId, doc.userDocId);
      if (response?.status === 200) {
        let documentUrl = null;

        if (doc.docType === "PASSPORT") {
          documentUrl = response.data.passportUrl;
        } else if (doc.docType === "SELFIEE") {
          if (doc.docIndex === 1) {
            documentUrl = response.data.selfieeUrl;
          } else if (doc.docIndex === 2) {
            documentUrl = response.data.videoUrl;
          }
        }

        if (documentUrl) {
          openDocumentWindow(documentUrl, doc.docType, doc.docIndex);
        } else {
          setError("Document URL not found");
        }
      } else {
        setError("Failed to fetch document");
      }
    } catch (error) {}
  };

  const openDocumentWindow = (url, docType, docIndex) => {
    const left = window.screen.width / 2 - 400;
    const top = window.screen.height / 2 - 350;
    const newWindow = window.open(
      "",
      "",
      `width=800,height=700,left=${left},top=${top}`
    );

    if (newWindow) {
      const isPdf = url.includes(".pdf");
      const isVideo =
        url.includes(".webm") || url.includes(".mp4") || docIndex === 2;

      const preventSaveCSS = `
      * { user-select: none; }
      body { margin: 0; overflow: hidden; }
    `;

      const preventSaveJS = `
      document.addEventListener('contextmenu', e => e.preventDefault());
      document.addEventListener('keydown', e => {
        if (
          (e.ctrlKey || e.metaKey) && ['s','p'].includes(e.key.toLowerCase()) ||
          (e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'i' ||
          e.key === 'PrintScreen'
        ) {
          e.preventDefault();
          return false;
        }
      });
    `;

      const content = DocumentView(url, isPdf, isVideo);

      newWindow.document.write(`
      <html>
        <head>
          <title>Document Preview - ${docType} ${
        docIndex === 2 ? "Video" : "Image"
      }</title>
          <style>${preventSaveCSS}</style>
        </head>
        <body style="margin:0">
          ${content}
          <script>${preventSaveJS}</script>
        </body>
      </html>
    `);

      newWindow.document.close();
      newWindow.addEventListener("beforeunload", () => {
        URL.revokeObjectURL(url);
      });
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case "APPROVED":
        return "#4CAF50";
      case "PENDING":
        return "#FF9800";
      case "REJECTED":
        return "#F44336";
      default:
        return "#FFFFFF";
    }
  };

  return (
    <div className={styles.container}>
      {dataLoading ? (
        <CustomSpinner />
      ) : Array.isArray(documents) && documents.length > 0 ? (
        <DataTable
          columns={documentColumns}
          list={documents}
          rowClick={false}
          handleDocumentDetails={handleViewDocuments}
        />
      ) : (
        <p style={{ color: "white", marginTop: "20px", textAlign: "center" }}>
          No Data Found
        </p>
      )}
      {error && (
        <p style={{ color: "red", marginTop: "20px", textAlign: "center" }}>
          {error}
        </p>
      )}
    </div>
  );
};

export default Document;
